import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import filters from './filters/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTypedJs from 'vue-typed-js'

// 全局公共样式
import './assets/css/global.css'
import './assets/css/animate.min.css'
import 'swiper/dist/css/swiper.css'
import 'video.js/dist/video-js.css'

// 配置请求的根路径
// axios.defaults.baseURL = 'http://dev-rte.yizhipao.work/api/v2'
axios.defaults.baseURL = 'https://www.rteconf.com/2022/api/v2'
// axios.defaults.baseURL = 'https://rteconf-pre.agora.io/2022/api/v2'
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$filter = filters
Vue.use(VueAwesomeSwiper)
Vue.use(VueTypedJs)

Object.keys(filters).map(v => {
  Vue.filter(v, filters[v])
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
